import React from 'react';
import { Label, Icon } from '@atlas/ui';
import { Link, useHistory, Redirect } from 'react-router-dom';
import { Bus, useApplicationState } from '@atlas/core';
import ConnectedBetHistory from 'common/History/BetHistory/BetHistory';

export default function IFrameBetHistory() {
  const { authenticated } = useApplicationState();

  const { goBack } = useHistory();
  const IFrameHeader = (
    <Link onClick={goBack} className="back-to-container bet-history_back">
      <Icon name="back" className="icon-back" />
      <Label className="title-text" message="bet_history" />
    </Link>
  );

  if (!authenticated) {
    Bus.emit(Bus.events.auth.loginRequired);
    return <Redirect to="/" />
  }

  return <ConnectedBetHistory iframeHeader={IFrameHeader} />;
}
